<template>
	<div class="loading">
		<div class="mt-3 pb-3" v-for="index in rowCount" :key="index" :style="{ borderBottom: index < rowCount ? '1px solid #ccc' : 'none' }">
			<div>
				<shimmer class="mt-1 ml-4 rounded-circle" :height="'20px'" :width="'20px'"/>
				<shimmer class="mt-1 ml-3" :height="'20px'" :width="'40px'"/>
				<shimmer class="mt-1 ml-3" :height="'20px'" :width="'120px'"/>
			</div>
			<div>
				<shimmer class="mt-3 ml-4" :height="'30px'" :width="'200px'"/>
			</div>
			<div>
				<shimmer class="mt-3 ml-4 w-50" :height="'10px'"/>
			</div>
		</div>
	</div>
</template>

<script>
import Shimmer from '@/components/Shimmer.vue';

export default {
	name: 'ListTextLoading',
	components: {
		Shimmer,
	},
	props: {
		rowCount: {
			type: Number,
			default: 3,
		},
	},
};
</script>
